module.exports = __webpack_public_path__ + "static/media/cfield.93ca4e74.png";